module.exports = __webpack_public_path__ + "static/media/quindio-63.4a9bad5f.jpg";